import LocationCityIcon from '@mui/icons-material/LocationCity'
import GemeentenList from './GemeentenList'
import GemeentenCreate from './GemeentenCreate'
import GemeentenShow from './GemeentenShow'
import GemeentenEdit from './GemeentenEdit'

const resource = {
  list: GemeentenList,
  create: GemeentenCreate,
  show: GemeentenShow,
  edit: GemeentenEdit,
  icon: LocationCityIcon,
}

export default resource
